<template>
	<div
		class="component c-galleries padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class="row padding-x-12 ">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div
			class="c-galleries__container row padding-x-12 d-block bp-768:d-flex padding-t-24 padding-b-18"
		>
			<div
				class="c-galleries__large width-100 bp-768:width-50 d-flex flex-wrap-wrap"
			>
				<div
					class="c-galleries__item  width-100"
					v-for="(image, index) in gallery_images.slice(0, 1)"
					v-on:click="open_modal(image)"
					:key="image.alt + 'Large' + index"
				>
					<div class="c-galleries__item-inside">
						<img
							:src="
								image && image.large
									? image.large
									: image.medium
							"
							:alt="image.caption + ' Large - #' + index"
						/>
					</div>
				</div>
			</div>
			<div
				class="c-galleries__smalls width-100 bp-768:width-50 d-flex flex-wrap-wrap"
			>
				<div
					v-for="(image, index) in gallery_images.slice(1, 5)"
					:key="image.caption + index"
					v-on:click="open_modal(image)"
					class="c-galleries__item width-50 "
				>
					<div class="c-galleries__item-inside">
						<img
							:src="
								image && image.large
									? image.large
									: image.medium
							"
							:alt="image.caption + ' Large - #' + index"
						/>
					</div>
				</div>
			</div>
		</div>
		<GalleryModal
			:key="renderKey"
			:selectedGallery="selectedGallery"
			:value="gallery_modal_toggled"
			v-on:input="close_gallery_modal(selectedGallery)"
		/>
		<div v-if="this.gallery_info" class="row margin-t-24 padding-x-24">
			<a
				class="s-common__button c-galleries__more font-size-14 line-height-125 font-weight-700"
				:href="
					'/galleries/' +
						this.gallery_info.sport.slug +
						'/' +
						this.gallery_info.title_slug +
						'/' +
						this.gallery_info.id
				"
				>View Full Gallery</a
			>
		</div>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import Client from '@/client';
import CommonHeader from '@/components/common/CommonHeader';
import GalleryModal from '@/components/modal/GalleryModal';
import { should_use_v2_api, slugify } from '@/helpers';

export default {
	extends: SectionBase,
	name: 'SectionGalleries',
	components: { CommonHeader, GalleryModal },
	data: () => ({
		renderKey: Date.now(),
		gallery_images: [],
		gallery_info: null,
		gallery_modal_toggled: false,
		selectedGallery: null,
	}),
	methods: {
		open_modal(image) {
			this.selectedGallery = image;
			this.gallery_modal_toggled = true;
		},
		close_gallery_modal() {
			this.gallery_modal_toggled = false;
		},
		get_images() {
			if (should_use_v2_api()) {
				this.fetch_images_from_v2_api();
			} else {
				this.fetch_images_from_legacy_api();
			}
		},
		fetch_images_from_legacy_api() {
			Client.get('/services/galleries.ashx/gallery', {
				params: {
					id: this.section.selectedGallery,
				},
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Content-type': 'application/json',
				},
			}).then(response => {
				if (
					response &&
					response.data &&
					response.data.data &&
					response.data.data.images
				) {
					this.gallery_info = response.data.data;
					if (response.data.data.images.length > 0) {
						this.gallery_images = response.data.data.images;
						this.selectedGallery = response.data.data.images[0];
					}
				}
			});
		},
		fetch_images_from_v2_api() {
			Client.get('/api/v2/ImageGalleries', {
				params: {
					includeImages: true,
					galleryId: this.section.selectedGallery,
				},
			}).then(response => {
				let data = null;
				if (response.data.length > 0) {
					data = this.map_v2_response(response.data[0]);
				}

				if (response && data && data.images) {
					this.gallery_info = data;
					if (data.images.length > 0) {
						this.gallery_images = data.images;
						this.selectedGallery = data.images[0];
					}
				}
			});
		},
		map_v2_response(data) {
			var mapped_data = {
				id: data.id,
				date: data.date,
				folder: '',
				note: '',
				title: data.title,
				title_slug: slugify(data.title),
				image: {
					caption: data.primaryImage.caption,
					caption_slug: slugify(data.primaryImage.caption),
					credit: data.primaryImage.credit,
					id: data.primaryImage.id,
					filename: data.primaryImage.imageUrl.original.substring(
						data.primaryImage.imageUrl.original.lastIndexOf('/') +
							1,
					),
					small: data.primaryImage.imageUrl.small,
					medium: data.primaryImage.imageUrl.medium,
					large: data.primaryImage.imageUrl.large,
					original: data.primaryImage.imageUrl.original,
					width: null,
					height: null,
					aspect_ratio: null,
					players: null,
				},
				image_count: data.images.length,
				images: data.images.map(x => ({
					caption: x.caption,
					caption_slug: slugify(x.caption),
					credit: x.credit,
					id: x.id,
					filename: x.imageUrl.original.substring(
						x.imageUrl.original.lastIndexOf('/') + 1,
					),
					small: x.imageUrl.small,
					medium: x.imageUrl.medium,
					large: x.imageUrl.large,
					original: x.imageUrl.original,
					width: null,
					height: null,
					aspect_ratio: null,
					players: null,
				})),
				sports: data.sports.map(x => ({
					id: x.id,
					title: x.title,
					abbreviation: x.abbreviation,
					slug: x.slug,
				})),
				tags: null,
				template: null,
				hidden: false,
				sport: null,
			};

			if (mapped_data.sports.length > 0) {
				mapped_data.sport = mapped_data.sports[0];
			}

			return mapped_data;
		},
	},
	created() {
		this.get_images();
	},
};
</script>

<style scoped lang="scss">
.c-galleries {
	&__item {
		cursor: pointer;
		overflow: hidden;
		&-inside {
			position: relative;
			height: 0;
			padding-bottom: 100%;
			overflow: hidden;
		}
		&:hover {
			img {
				transition: 0.25s;
				transform: scale(1.05);
			}
		}
		img {
			height: 100%;
			left: 0;
			position: absolute;
			top: 0;
			width: 100%;
			transition: 0.25s;
			transform: scale(1);
			object-fit: cover;
			object-position: center;
		}
	}
	&__large {
		.c-galleries__item {
			border: 1px solid $main-border-color;
			box-sizing: border-box;
			border-radius: 10px 0px 0px 10px;
		}
	}
	&__smalls {
		.c-galleries__item {
			border: 1px solid $main-border-color;
			box-sizing: border-box;
			&:nth-child(2) {
				border: 1px solid $main-border-color;
				box-sizing: border-box;
				border-radius: 0px 10px 0px 0px;
			}
			&:nth-child(4) {
				border: 1px solid $main-border-color;
				box-sizing: border-box;
				border-radius: 0px 0px 10px 0px;
			}
		}
	}
	@media screen and (max-width: 768px) {
		&__container {
			display: block !important;
		}
		&__large,
		&__smalls {
			width: 100% !important;
		}
		&__large {
			.c-galleries {
				&__item {
					border: 1px solid $main-border-color;
					box-sizing: border-box;
					border-radius: 10px 10px 0px 0px;
				}
			}
		}
		&__smalls {
			.c-galleries {
				&__item {
					border: 1px solid $main-border-color;
					box-sizing: border-box;
					border-radius: 0px !important;
					&:nth-child(3) {
						border-radius: 0px 0px 0px 10px !important;
					}
					&:nth-child(4) {
						border-radius: 0px 0px 10px 0px !important;
					}
				}
			}
		}
	}
}
</style>
